import * as constants from "./constants";

export const startWorkSession = (tasks, initialIndex = 0) => ({
  type: constants.START_WORK_SESSION,
  payload: { tasks, initialIndex },
});

export const endWorkSession = () => ({
  type: constants.END_WORK_SESSION,
});

export const setWorkSessionIndex = (index) => ({
  type: constants.SET_WORK_SESSION_INDEX,
  payload: index,
});

export const nextWorkSessionTask = () => ({
  type: constants.NEXT_WORK_SESSION_TASK,
});

export const prevWorkSessionTask = () => ({
  type: constants.PREV_WORK_SESSION_TASK,
});

export const setWorkSessionTaskHandled = (taskId, status) => ({
  type: constants.SET_WORK_SESSION_TASK_HANDLED,
  payload: { taskId, status },
});

export const updateWorkSessionTask = (taskId, taskData) => ({
  type: constants.UPDATE_WORK_SESSION_TASK,
  payload: { taskId, taskData },
});

export const openWorkSessionModal = (modalType) => ({
  type: constants.OPEN_WORK_SESSION_MODAL,
  payload: modalType,
});

export const closeWorkSessionModal = () => ({
  type: constants.CLOSE_WORK_SESSION_MODAL,
});
